import { render, staticRenderFns } from "./OpenRegistrationSettingsForm.vue?vue&type=template&id=14e29e06"
import script from "./OpenRegistrationSettingsForm.vue?vue&type=script&lang=js"
export * from "./OpenRegistrationSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports